import { render } from "./ApiKeysTable.vue?vue&type=template&id=25ca572a"
import script from "./ApiKeysTable.vue?vue&type=script&lang=js"
export * from "./ApiKeysTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__